import type { WizardStep } from '../types/create-experiment.types';

/**
 * Map the backend's draft `stage` enum to the wizard's numeric step. Source
 * of truth for the resume flow — `hydrate-draft.ts` reads from this so the
 * mapping isn't duplicated. Unknown stages fall back to step 1 (start over)
 * rather than throwing, so a forward-compatible backend addition can't lock
 * users out of resume.
 */
const STAGE_TO_STEP: Record<string, WizardStep> = {
  DEFINE_PRODUCT_GROUPS: 1,
  DEFINE_SCOPE: 2,
  ANALYTICS_SETUP: 3,
  EXPERIMENT_STRATEGY: 4,
  REVIEW_AND_LAUNCH: 5,
};

/**
 * Map an API `stage` value to its wizard step (defaults to 1). Accepts a
 * loose `string` so the unknown-stage path stays defensive — the
 * `DraftStage` union (`(string & {})` branch) collapses to `string` anyway.
 */
export function stageToStep(stage: string | null | undefined): WizardStep {
  if (!stage) return 1;
  return STAGE_TO_STEP[stage] ?? 1;
}
